import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import { DATA_BINDING } from '@wix/app-definition-ids'
import type { DatasetType } from '@wix/wix-data-client-types'
import { DATASET } from '@wix/wix-data-client-types'
import { ComponentTypes } from '@wix/wix-data-client-common-standalone'

export const componentIsUnconfiguredRegularDataset = async ({
  editorSdkProxy,
  componentRef,
  componentSdkType,
}: {
  editorSdkProxy: EditorSDK
  componentRef: ComponentRef
  componentSdkType: string
}) => {
  if (componentSdkType !== ComponentTypes.AppController) {
    return false
  }

  const result = await Promise.all([
    editorSdkProxy.components.data.get({ componentRef }),
    editorSdkProxy.controllers.getData({
      controllerRef: componentRef,
    }),
  ])

  const [componentData, datasetData] = result as [
    {
      applicationId: string | undefined
      settings: string | undefined
    },
    { type: DatasetType; config?: { dataset?: { collectionName?: string } } },
  ]

  const hasConfiguredCollection = datasetData.config?.dataset?.collectionName

  return (
    datasetData.type === DATASET &&
    componentData.applicationId === DATA_BINDING &&
    !hasConfiguredCollection
  )
}
